export const uk = {
    bannerPrice: 'Цена в объявлении'
};
